var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormulationManagementData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88889 23.3333H0V31.1111C0 33.25 1.75 35 3.88889 35H11.6667V31.1111H3.88889V23.3333ZM3.88889 3.88889H11.6667V0H3.88889C1.75 0 0 1.75 0 3.88889V11.6667H3.88889V3.88889ZM31.1111 0H23.3333V3.88889H31.1111V11.6667H35V3.88889C35 1.75 33.25 0 31.1111 0ZM31.1111 31.1111H23.3333V35H31.1111C33.25 35 35 33.25 35 31.1111V23.3333H31.1111V31.1111Z",
    fill: "url(#paint0_linear_1153_21998)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4853 27.2218L19.7432 24.0096L20.8999 22.7676L22.4853 24.47L26.0651 20.6261L27.2218 22.1358L22.4853 27.2218ZM7.77734 7.77734H25.7261V9.9188C24.6292 9.9188 23.7318 10.8825 23.7318 12.0603V17.4139C22.6818 17.4148 21.6505 17.7121 20.7414 18.2761C19.8322 18.84 19.0771 19.6508 18.5518 20.627C18.0266 21.6032 17.7496 22.7105 17.7487 23.838C17.7477 24.9654 18.0229 26.0733 18.5466 27.0505H11.7659C10.6691 27.0505 9.77165 26.0868 9.77165 24.909V12.0603C9.77165 10.8825 8.87421 9.9188 7.77734 9.9188V7.77734ZM11.7659 14.2017V15.2724H14.7574V14.2017H11.7659ZM11.7659 16.3432V17.4139H14.7574V16.3432H11.7659ZM14.7574 21.6968V20.6261H11.7659V21.6968H14.7574ZM16.7517 19.5554V18.4846H11.7659V19.5554H16.7517ZM16.7517 13.131V12.0603H11.7659V13.131H16.7517Z",
    fill: "url(#paint1_linear_1153_21998)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1153_21998",
    x1: 17.5,
    y1: 0,
    x2: 17.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1153_21998",
    x1: 17.4996,
    y1: 7.77734,
    x2: 17.4996,
    y2: 27.2218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormulationManagementData);
export default __webpack_public_path__ + "static/media/Formulation_Management_Data.ad0ab1e2655871ce3ef44ae32cc71fcf.svg";
export { ForwardRef as ReactComponent };